
import { Button } from "@/components/ui/button";
import { CheckIcon, Loader2 } from "lucide-react";
import { PricingPlan } from "../types/pricingTypes";

interface PricingCardProps {
  plan: PricingPlan;
  onSubscribe: () => Promise<void>;
  isLoading: boolean;
  disabled: boolean;
}

export const PricingCard = ({ plan, onSubscribe, isLoading, disabled }: PricingCardProps) => {
  return (
    <div
      className={`flex flex-col rounded-lg border bg-white shadow-sm ${
        plan.highlighted ? "border-primary shadow-lg" : "border-border"
      } p-6 relative`}
    >
      {plan.highlighted && (
        <div className="absolute top-0 -translate-y-1/2 rounded-full bg-primary px-3 py-1 text-sm text-primary-foreground">
          Most Popular
        </div>
      )}
      <div className="mb-4">
        <h2 className="text-2xl font-bold">{plan.name}</h2>
        <div className="mt-4 flex items-baseline">
          <span className="text-4xl font-extrabold tracking-tight">{plan.price}</span>
          {plan.period && (
            <span className="ml-1 text-sm text-muted-foreground">{plan.period}</span>
          )}
        </div>
        <p className="mt-2 text-sm text-muted-foreground">{plan.description}</p>
      </div>
      <ul className="mb-6 space-y-3 text-sm">
        {plan.features.map((feature) => (
          <li key={feature} className="flex items-center">
            <CheckIcon className="mr-2 h-4 w-4 text-primary" />
            <span>{feature}</span>
          </li>
        ))}
      </ul>
      <div className="mt-auto">
        {plan.name === "Free" ? (
          <Button variant={plan.buttonVariant} className="w-full" disabled>
            Current Plan
          </Button>
        ) : (
          <Button
            variant={plan.buttonVariant}
            className="w-full"
            disabled={disabled || isLoading}
            onClick={onSubscribe}
          >
            {isLoading ? (
              <>
                <Loader2 className="h-4 w-4 animate-spin mr-2" />
                Processing...
              </>
            ) : (
              plan.buttonText
            )}
          </Button>
        )}
      </div>
    </div>
  );
};
